import type { BookingDocument } from '../types';
import { BOOKING_DOC_MAX_BYTES } from '../../functions/src/bookingDocumentCompression.mjs';

const FILE_TYPES: Record<string, string> = {
  pdf: 'application/pdf', eml: 'message/rfc822', txt: 'text/plain', csv: 'text/csv',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', xls: 'application/vnd.ms-excel',
  jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp',
};

export interface ItineraryOriginal {
  name: string;
  size: number;
  contentType: string;
  sha256: string;
  document?: BookingDocument;
}

/** Pickers often supply empty or generic MIME types, especially on iOS. */
export function itineraryFileType(file: File): string {
  const contentType = FILE_TYPES[file.name.split('.').pop()?.toLowerCase() || ''];
  if (!contentType) throw new Error('Unsupported file. Use PDF, email (.eml), Word (.docx), Excel, CSV, text or an image.');
  return contentType;
}

export async function describeItineraryFile(file: File): Promise<ItineraryOriginal> {
  if (!file.size) throw new Error('The file is empty.');
  if (file.size >= BOOKING_DOC_MAX_BYTES) throw new Error('Each attachment must be smaller than 15 MiB.');
  const contentType = itineraryFileType(file);
  const digest = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
  return { name: file.name, size: file.size, contentType,
    sha256: Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('') };
}
